<template>
    <form @submit.prevent="submit()">
        <input type="hidden" name="typeswitch" value="leren">
        
        <div class="row row--fields">
            <div class="column">
                <div class="headersearch__title h5">Ik wil iets leren</div>
            </div>
        </div>
        <div class="row row--fields">
            <div class="column small-24 medium-14">
                <div class="formfield input input--zip">
                    <LocationSearch name="plaats" />
                </div>
            </div>
            <div class="column small-24 medium-10">
                <div class="formfield select">
                    <div class="customselect">
                        <select name="distance">
                            <option value="1">+ 10 km</option>
                            <option value="2">+ 20 km</option>
                            <option value="3">+ 30 km</option>
                            <option value="4">+ 40 km</option>
                        </select>
                    </div>
                </div>
            </div>
        </div>
        <div class="row row--fields">
            <div class="column">
                <div class="formfield">
                    <div class="customselect">
                        <select name="activity[]">
                            <option value="1" v-for="item in selectItems" :value="item.value">{{ item.key }}</option>
                        </select>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="column">
                <div class="btn__headersearch">
                    <button class="btn">Zoeken in aanbod <i class="icon-arrow-right"></i></button>
                </div>
            </div>
        </div> 
    </form>
</template>

<script>
    import LocationSearch from '@/components/LocationSearch.vue';
    import SerializeObject from '@/helpers/formSerialize';
    import axios from 'axios';

    export default {
        components: {
            LocationSearch
        },
        data() {
            return {
                selectItems: []
            }
        },
        mounted() {
            axios.get('/_activities', {
                params: {
                    type: 'leren'
                }
            })
                .then((response) => {
                    this.selectItems = response.data;
                })
                .catch((error) => {
                    this.error = error;
                });
        },
        methods: {
            submit() {
                const formdata = btoa(JSON.stringify(SerializeObject($(this.$el))));
                const url = `/aanbod#!filter:${formdata}`;

                window.location = url;
            }
        }
    }
</script>
